import React, { useContext, useEffect, useState } from "react";
import { Button, ExpandableButton } from "../../components";
import check from "../../assets/icons/green_check_circle_icon.png";
import {
  AxiosContext,
  PaymentTokenizationContext,
  ShopContext,
} from "../../context";
import {CreateTokenizationUrlData, InfoMessageId, PaymentData} from "../../context/types";
import { v4 as uuid } from "uuid";
import config from "../../config/config";
import LogEvents from "../../services/logEvents";

const FailedPage: React.FC = () => {
  const { shop, shopMessages } = useContext(ShopContext);
  const { setDisplayLoader } = useContext(AxiosContext);
  const { createTokenizationUrl } = useContext(PaymentTokenizationContext);

  // todo: refactor - same method in Info page!!!
  const redirectToPayment = async () => {
    const shopDataLocal = JSON.parse(localStorage.getItem("shopData")!);
    const createTokenizationUrlData: CreateTokenizationUrlData = {
      shopId: shopDataLocal.shopId,
      language: shopDataLocal.currentLanguage,
      successUrl: config.paymentTokenizationSuccessUrl,
      failedUrl: config.paymentTokenizationFailedUrl,
    }

    setDisplayLoader(true);

    await createTokenizationUrl(createTokenizationUrlData)
        .then((response: string) => {
          window.location.href = response;
        })
  };

  const [text, setText] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    setText(shopMessages?.TOKENIZATION?.PAYMENT_TOKENIZATION_FAILEDTEXT);
    setTitle(shopMessages?.TOKENIZATION?.PAYMENT_TOKENIZATION_FAILEDTITLE);
  }, [shopMessages]);

  useEffect(() => {
    LogEvents.logEvent(InfoMessageId.payment_token_failed, "Tokenization failed");
    // LogEvents.logEvents("paymentTokenizationFailed", "Tokenization failed");
  }, []);

  return (
    <div className="payment-tokenization failed">
      <div className="payment-tokenization__lang_dropdown_button">
        <ExpandableButton type="green" />
      </div>

      <div className="card">
        <div
          className="title"
          dangerouslySetInnerHTML={{ __html: title }}
        ></div>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>
        <Button
          type="white"
          rightIcon={check}
          clickHandler={() => redirectToPayment()}
          text={shopMessages?.TOKENIZATION?.FAILED?.BUTTON}
        />
      </div>
    </div>
  );
};

export default FailedPage;
